import DashboardCount, { DashboardCountRef } from "./dashboard-count";
import Milks from "./Milks";
import Products from "./Products";
import dayjs from "dayjs";
import ChartContainer from "./chart";
import { formatDate, parseDate } from "@progress/kendo-intl";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import { API_END_POINT } from "../../constants";
import HomePageModel from "../../models/transaction/homepage-model";
import FermentedMilk from "./fermentedmilk";
import { RefreshIcon } from "../../assets/images/refresh-icon";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FileSearchIcon } from "../../assets/images/file-search";
import ReportIcon from "../../assets/images/report";
import { string } from "yup";

const Dashboard: React.FC = () => {
  const dashboardCountRef = useRef<DashboardCountRef>(null);
  const handleRefreshClick = () => {
    dashboardCountRef.current?.refresh();
  };
  const [orderDate, setOrderDate] = useState<Date>(new Date());

  const handleDateChange = () => {

  };
  useEffect(() => {
    // const today = new Date();
    // const day = today.getDate().toString().padStart(2, "0");
    // const month = (today.getMonth() + 1).toString().padStart(2, "0");
    // const year = today.getFullYear();
    // const formattedDate = `${year}-${month}-${day}`;

  }, [orderDate]);

  return (
    <>
      <div className="m-lg-5 mt-lg-3 m-4">
        <div className="d-flex justify-content-between pt-3 pb-3">
          <div className="d-flex col-12">
            {/* <div>
              <input
                type="text"
                className="form-control ms-auto search-right-align searchBg"
                placeholder="Search"
              />
            </div> */}
            <div className="me-2 d-flex">
              <DatePicker
                selectsMultiple={true}
                openToDate={orderDate}
                className="form-control ms-auto search-right-align calendarBg"
                value={formatDate(orderDate, "dd/MM/yyyy")}
                placeholderText="To"
                dateFormat={"dd/MM/yyyy"}
                maxDate={new Date()}
                onChange={([date]: any) => {
                  setOrderDate(date);
                }}
              />
              {/* <OverlayTrigger
                overlay={(props) => (
                  <Tooltip {...props}>Click find data for selected date</Tooltip>
                )}
                placement="bottom"
              >
                <Button  onClick={() => { handleDateChange()}}
                    className="ms-2 btn btn-outline-secondary btn-sm"
                >Go</Button>
              </OverlayTrigger> */}
            </div>
            <OverlayTrigger
              overlay={(props) => (
                <Tooltip {...props}>Reload the Counts</Tooltip>
              )}
              placement="bottom-start"
            >
              <div
                className="d-flex ms-auto refresh-container"
                onClick={() => handleRefreshClick()}
              >
                <RefreshIcon></RefreshIcon>
              </div>
            </OverlayTrigger>
          </div>
        </div>
        <div>
          <DashboardCount
            ref={dashboardCountRef}
            porderDate={orderDate}
            inactiveClass=""
          ></DashboardCount>
        </div>
        <div>
          <div className="grid-row">
            <Milks type="Milk"
              porderDate={orderDate}
            ></Milks>
            <FermentedMilk
              pOrderDate={orderDate}
              type="Fermented Milk"></FermentedMilk>
          </div>
          <div className="grid-row mt-3">
            <Products type="Product"
              pOrderDate={orderDate}
            ></Products>
          
            <ChartContainer></ChartContainer>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;
